import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {TableService} from "@app/ps/services/table.service";
import {SettingsService} from "@app/ps/services/settings.service";
import {UserNamePipe} from "@app/common/pipes/username.pipe";
import {OpinionRequestService} from "@app/ps/services/opinion-request.service";
import {OpinionRequestModel} from "@app/ps/models/opinion-request.model";

@Component({
  selector: 'table-opinion-request',
  templateUrl: './table-opinion-request.component.html',
})
export class TableOpinionRequestComponent implements OnInit {
  @Input() list: any;
  @Input() clickable = false;
  @Output() sort = new EventEmitter();
  @Output() onclick = new EventEmitter();

  constructor(
    private tableService: TableService,
    private settingsService: SettingsService,
    public userNamePipe: UserNamePipe,
    public requestService: OpinionRequestService,
  ) {}

  private readonly TABLE_ID = 'opinionRequests';
  public isArray = Array.isArray;

  ngOnInit() {
  }

  onClick(opinion: OpinionRequestModel) {
    this.onclick.emit(opinion);
  }

  onSort(column: string, ascOrDesc: string) {
    this.sort.emit({
      column,
      ascOrDesc,
    });
  }

  hideColumn(columnId: string): boolean {
    return this.settingsService.shouldHideColumn(this.TABLE_ID, columnId);
  }

  getColumnName(columnId: string): string {
    return this.tableService.getColumnById(this.TABLE_ID, columnId).name;
  }
}
